// His name for a round on B7's screens (GLOSSARY §22, §23.8): V1's stored "Onsite Round n" reads as Final Interview
// Loop · Round n, as the server's `shell_vocab.his_title` rewords the shell's rows and the panel lane's DeclineDialog
// rewords its own; any other label (the Recruiter screen, the HM interview) is drawn as the server gives it.

import { LABEL_TEMPLATES } from "@/mc";

const V1_ROUND = /(?<![\w])Onsite Round (\d+)(?![\w])/g;

export function hisRoundLabel(label: string): string;
export function hisRoundLabel(label: string | null | undefined): string | null;
export function hisRoundLabel(label: string | null | undefined): string | null {
  if (!label) return label ?? null;
  return label.replace(V1_ROUND, (_, n: string) => LABEL_TEMPLATES.finalLoopRound({ n: Number(n) }));
}

/** Whether the label names a round of the loop (and so already says Final Interview Loop once reworded). */
export const isLoopRound = (label: string | null | undefined): boolean => !!label && new RegExp(V1_ROUND.source).test(label);
